import { render, staticRenderFns } from "./GenerateGuiderRegistrationCode.vue?vue&type=template&id=4f510480&scoped=true"
import script from "./GenerateGuiderRegistrationCode.vue?vue&type=script&lang=js"
export * from "./GenerateGuiderRegistrationCode.vue?vue&type=script&lang=js"
import style0 from "./GenerateGuiderRegistrationCode.vue?vue&type=style&index=0&id=4f510480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f510480",
  null
  
)

export default component.exports